export default __webpack_public_path__ + "static/final-cta-background-0f38e0b44d882121c5135664db5388b9.webp";